import {useState} from "react";
import URLS from "../API/Axios/URLS";
import axiosInstance from "../API/Axios/AxiosConfig";
import {toast} from "react-toastify";


export default function UseCefr() {
    const [data, setData] = useState(null);
    const [error, setError] = useState({
        non_field_errors: null,
    });
    const [isLoading, setIsLoading] = useState(false);


    function checkCefr(type,text) {
        if (isLoading) return;
        setIsLoading(true)
        axiosInstance.post(URLS.checkCefr, {
            type: type,
            text: text,
        }).then(res => {
            setData(res.data)
        }).catch(err => {
            setData(null)
            const errorMessages = err.response?.data?.message || err.response?.data?.detail || "Something went wrong"
            setError( {
                non_field_errors : [errorMessages]
            });

            toast(errorMessages,{
                type: "error"
            })
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const actions = {
        checkCefr,
        setError,
        setData,
    }

    return [data, error, isLoading, actions]
}